module.exports = __webpack_public_path__ + "img/logo.ad39d6ac.svg";